import { render } from "./QuestionTitle.vue?vue&type=template&id=08bcd8b2&scoped=true"
import script from "./QuestionTitle.vue?vue&type=script&lang=js"
export * from "./QuestionTitle.vue?vue&type=script&lang=js"

import "./QuestionTitle.vue?vue&type=style&index=0&id=08bcd8b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08bcd8b2"]])

export default __exports__